<template>
  <p class="field">
    <slot />
  </p>
</template>

<script>
export default {
  name: 'app-settings-control'
}
</script>
